
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { EnrichedVisitor } from "@/types/database";
import { toast } from "sonner";
import CompanyInsights from "./CompanyInsights";

interface VisitorInsightGeneratorProps {
  visitor: EnrichedVisitor | null;
  isOpen: boolean;
}

const VisitorInsightGenerator = ({ visitor, isOpen }: VisitorInsightGeneratorProps) => {
  const [insights, setInsights] = useState<string | null>(null);

  const generateInsights = async () => {
    if (!visitor) return;

    try {
      // Generate insights directly using the existing visitor data without additional enrichment
      const { data, error } = await supabase.functions.invoke('generate-visitor-insights', {
        body: {
          company_name: visitor.company_name,
          company_industry: visitor.company_industry,
          company_size: visitor.company_size,
          page_url: visitor.page_url,
          location: visitor.location_locality && visitor.location_country 
            ? `${visitor.location_locality}, ${visitor.location_country}`
            : undefined
        }
      });

      if (error) throw error;
      if (!data?.insights) throw new Error('No insights received');

      setInsights(data.insights);
    } catch (error) {
      toast.error('Failed to generate insights. Please try again.');
    }
  };

  // Generate insights when the card opens with a new visitor
  useEffect(() => {
    if (isOpen && visitor) {
      generateInsights();
    }
  }, [isOpen, visitor?.id]);

  return (
    <CompanyInsights 
      insights={insights}
      onRegenerate={generateInsights}
    />
  );
};

export default VisitorInsightGenerator;
